export const enum NavScrollContentTypes {
    TIMELINE = 'timeline',
    TEXT = 'text',
    HTML = 'html'
}